<template>
  <div>
    <form-field-select
      label="Channel"
      v-model="form.channel"
      :validation-errors="validationErrors.channel"
    >
      <option
        v-for="channel in ENUMS.CampaignChannelEnum"
        :key="channel.value"
        :value="channel.value"
      >{{ channel.label }}</option>
    </form-field-select>

    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-input
      label="Units Label"
      v-model="form.units_label"
      :validation-errors="validationErrors.units_label"
    ></form-field-input>

    <form-field-select-integration-phone-number
      label="Phone Number"
      v-model="form.integration_phone_number_id"
      :validation-errors="validationErrors.integration_phone_number_id"
    ></form-field-select-integration-phone-number>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "CampaignForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          channel: null,
          label: null,
          units_label: null,
          integration_phone_number_id: null,
          market_id: this.$store.getters.market.id
        },
      }
    },
    created() {
      this.form = this.$utils.clone(this.defaultForm);

      if (this.formData) {
        this.form = this.$utils.clone(this.formData)
        this.form.integration_phone_number_id = (this.formData.integrationPhoneNumber) ? this.$utils.clone(this.formData.integrationPhoneNumber.id) : null
      }
    },
    methods: {
      update() {
        return this.$api.campaigns.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Campaign was updated',
              type: 'is-success'
            });

            return res;
          });
      },
      create() {
        return this.$api.campaigns.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Campaign was created',
              type: 'is-success'
            });

            return res;
          });
      },
      delete() {
        return this.$utils.confirm(
          `Are you sure you want to archive ${this.form.label}?`,
          `Archive ${this.form.label}`
        ).then(() => {
          return this.$api.campaigns.delete(this.form.id)
            .then(res => {
              this.$buefy.toast.open({
                message: res.data,
                type: 'is-success'
              });

              return res;
            });
        })
      },
      restore() {
        return this.$utils.confirm(
          `Are you sure you want to restore ${this.form.label}?`,
          `Restore ${this.form.label}`
        ).then(() => {
          return this.$api.campaigns.restore(this.form.id)
            .then(res => {
              this.$buefy.toast.open({
                message: res.data,
                type: 'is-success'
              });

              return res;
            });
        });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
